import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { PaymentCardCont, StatusButton } from './style';

export default function PaymentCard({ Icon, status, handleClick, infoBtn, type }) {
  const language = useSelector((state) => state?.auth?.language);
  const handleInfoClick = (e) => {
    e.preventDefault();
    if (infoBtn) {
      infoBtn();
    }
  };
  const getContent = () => {
    switch (status) {
      case 'pending':
        return language?.content?.PAYMENT_METHOD_STATUS_DESCRIPTION?.pending;
      case 'connected':
        return language?.content?.PAYMENT_METHOD_STATUS_DESCRIPTION?.connected;
      case 'disconnected':
        return language?.content?.PAYMENT_METHOD_STATUS_DESCRIPTION?.disconnected;
      default:
        return 'NA';
    }
  };

  const handleCardOrStatusClick = () => {
    switch (type) {
      case 'stripe':
        if (status === 'pending') {
          handleClick();
          // dispatch(updateURLs({ url: 'stripe' }));
        }
        break;

      case 'alma':
        if (status !== 'disconnected' && status !== 'not_applicable') {
          handleClick();
        }
        break;

      default:
        // Handle other types if needed
        break;
    }
  };

  const onCardClick = (e) => {
    if (e.target.closest('.info-button')) return;
    handleCardOrStatusClick();
  };

  const isClickable =
    (type === 'stripe' && status === 'pending') ||
    (type === 'alma' && status !== 'disconnected' && status !== 'not_applicable');

  return (
    <PaymentCardCont
      role="button"
      tabIndex={0}
      status={status}
      $clickable={isClickable}
      onClick={onCardClick}
      onKeyDown={(e) => e.key === 'Enter' && onCardClick(e)}
    >
      <img src={Icon} alt="stripe_icon" />
      {/* <button type="button" className="icon-button">
      </button> */}

      <div className="card-content-right">
        <StatusButton status={status} onClick={(e) => { e.stopPropagation(); handleCardOrStatusClick(); }}>
          {getContent()}
        </StatusButton>

        {status === 'pending' && (
          <button
            type="button"
            onClick={handleInfoClick}
            className="info-button mobile-info-button"
            aria-label="More information"
          >
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.90918 15.0312H11.9092V9.03125H9.90918V15.0312ZM10.9092 7.03125C11.1925 7.03125 11.43 6.93542 11.6217 6.74375C11.8133 6.55208 11.9092 6.31458 11.9092 6.03125C11.9092 5.74792 11.8133 5.51042 11.6217 5.31875C11.43 5.12708 11.1925 5.03125 10.9092 5.03125C10.6258 5.03125 10.3883 5.12708 10.1967 5.31875C10.005 5.51042 9.90918 5.74792 9.90918 6.03125C9.90918 6.31458 10.005 6.55208 10.1967 6.74375C10.3883 6.93542 10.6258 7.03125 10.9092 7.03125ZM10.9092 20.0312C9.52585 20.0312 8.22585 19.7688 7.00918 19.2437C5.79251 18.7188 4.73418 18.0063 3.83418 17.1063C2.93418 16.2063 2.22168 15.1479 1.69668 13.9313C1.17168 12.7146 0.90918 11.4146 0.90918 10.0312C0.90918 8.64792 1.17168 7.34792 1.69668 6.13125C2.22168 4.91458 2.93418 3.85625 3.83418 2.95625C4.73418 2.05625 5.79251 1.34375 7.00918 0.81875C8.22585 0.29375 9.52585 0.03125 10.9092 0.03125C12.2925 0.03125 13.5925 0.29375 14.8092 0.81875C16.0258 1.34375 17.0842 2.05625 17.9842 2.95625C18.8842 3.85625 19.5967 4.91458 20.1217 6.13125C20.6467 7.34792 20.9092 8.64792 20.9092 10.0312C20.9092 11.4146 20.6467 12.7146 20.1217 13.9313C19.5967 15.1479 18.8842 16.2063 17.9842 17.1063C17.0842 18.0063 16.0258 18.7188 14.8092 19.2437C13.5925 19.7688 12.2925 20.0312 10.9092 20.0312ZM10.9092 18.0312C13.1425 18.0312 15.0342 17.2563 16.5842 15.7063C18.1342 14.1562 18.9092 12.2646 18.9092 10.0312C18.9092 7.79792 18.1342 5.90625 16.5842 4.35625C15.0342 2.80625 13.1425 2.03125 10.9092 2.03125C8.67585 2.03125 6.78418 2.80625 5.23418 4.35625C3.68418 5.90625 2.90918 7.79792 2.90918 10.0312C2.90918 12.2646 3.68418 14.1562 5.23418 15.7063C6.78418 17.2563 8.67585 18.0312 10.9092 18.0312Z"
                fill="black"
              />
            </svg>
          </button>
        )}
      </div>
    </PaymentCardCont>
  );
}

PaymentCard.propTypes = {
  Icon: PropTypes.string.isRequired,
  // content: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  infoBtn: PropTypes.func,
  type: PropTypes.string.isRequired,
};
